<template>
<div class="section-gap info splash-left">
    <div class="container splash-right">
    <div class="section-title-wrapper extra-p">
          <div class="fullscreen-row">
            <div class="col-sm-12 mx-auto splash-container splash-s d-flex extra-p">
              <h1 class="h1-larger">Infos</h1>
            </div>
          </div>
        </div>    
    <div class="row d-flex">
      <div class="col-sm-6 col-md-6 col-lg-3 text-center" data-aos="zoom-in-down" data-aos-duration="1000"  v-for="(item,i) of items1.array"
            :key="i" >
            <div class="main-section ">
          <div class="row">
              <div class="col-lg-12 col-sm-12 col-12 user-detail"   @mouseover="hover = i"
    @mouseleave="hover = 10" >
                  
                  <img v-if="hover == i" :src="item.image_orange" class="img-thumbnail" />
                  <img v-else :src="item.image_white" class="img-thumbnail" />
                  <div class="col-lg-12 text-content">
                      <div style="padding-top: 30px">
                  <h5>{{item.title}}</h5>
                  <p class="pre-formatted">{{item.text}}</p>
                      </div>
                  </div>
              </div>
          </div>
            </div>
      </div>
    </div>
    <div class="row d-flex">
      <div class="col-sm-6 col-md-6 col-lg-3 text-center" data-aos="zoom-in-down" data-aos-duration="1000"  v-for="(item2,j) of items2.array"
            :key="j" >
            <div class="main-section ">
          <div class="row ">
              <div class="col-lg-12 col-sm-12 col-12 user-detail"  @mouseover="hover2 = j"
    @mouseleave="hover2 = 10" >
                  <img v-if="hover2 == j" :src="item2.image_orange" class="img-thumbnail" />
                  <img v-else :src="item2.image_white" class="img-thumbnail" />
                  <div class="col-lg-12 text-content">
                      <div style="padding-top: 30px">
                  <h5>{{item2.title}}</h5>
                  <p class="pre-formatted">{{item2.text}}</p>
                      </div>
                  </div>
              </div>
          </div>
            </div>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Info",
  data(){
    return {
        hover: 10,
        hover2: 10,
        items1: {
            array: [
                {
                    image_white: "/static/img/icons/White/controller_white.png",
                    image_orange: "/static/img/icons/Orange/controller_orange.png",
                    title: "Konsole",
                    text: "PS4"
                },
                 {
                    image_white: "/static/img/icons/White/game_white.png",
                    image_orange: "/static/img/icons/Orange/game_orange.png",
                    title: "Game",
                    text: "FIFA21"
                },
                 {
                    image_white: "/static/img/icons/White/participants_white.png",
                    image_orange: "/static/img/icons/Orange/participants_orange.png",
                    title: "Teilnehmer",
                    text: "max 128 pro Qualifier\n Top 32 beim Finalevent"
                },
                 {
                    image_white: "/static/img/icons/White/micro_white.png",
                    image_orange: "/static/img/icons/Orange/micro_orange.png",
                    title: "Live-Kommentar",
                    text: "Mario Viska,\nFlorian Madlberger"
                },
    
            ]
        },
        items2: {
            array: [
                {
                    image_white: "/static/img/icons/White/modus_white.png",
                    image_orange: "/static/img/icons/Orange/modus_orange.png",
                    title: "Modus",
                    text: "90er Modus\n Bis Viertelfinale: Best of 1\nAb Halbfinale: Hin- und \nRückspiel"
                },
                 {
                    image_white: "/static/img/icons/White/dauer_white.png",
                    image_orange: "/static/img/icons/Orange/dauer_orange.png",
                    title: "Spieldauer",
                    text: "6 Minuten\n pro Halbzeit"
                },
                 {
                    image_white: "/static/img/icons/White/team_white.png",
                    image_orange: "/static/img/icons/Orange/team_orange.png",
                    title: "Teams",
                    text: "Klubmannschaften"
                },
                 {
                    image_white: "/static/img/icons/White/livestream_white.png",
                    image_orange: "/static/img/icons/Orange/livestream_orange.png",
                    title: "Livestream",
                    text: "Twitch, Laola1, RapidTV"
                },
            ]
        }
    }
  },
};
</script>
<style scoped>
.info {
    background-color: black;
}
.main-section {

   background: linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.9)),
    linear-gradient(white, white);
    margin-bottom: 30%;
}

.pre-formatted {
  white-space: pre;
}

.extra-p {
    padding-bottom: 50px;
}
.text-content {
    height: 100%;
}
.user-detail{
 margin:-40px 0px 30px 0px; 
 height: 240px;
  
}
.user-detail img{
	height:30%;
    background-color: transparent;
    border: none;
}
.user-detail h5{
	margin:15px 0px 5px 0px;
}

.splash-s {
  background-image: url(/static/img/splash_qualifier_red.png);
  background-position: 60% 0%;
  background-repeat: no-repeat;
  /* width: 100%; */
  min-height: 120px;
  background-size: 110px;
}

.splash-left {
    background-image: url(/static/img/splash-info-left.png);
  background-position: 15% 55%;
  background-repeat: no-repeat;
  /* width: 100%; */
  min-height: 120px;
  background-size: 120px;
}

.splash-right {
    background-image: url(/static/img/splash-info-right.png);
  background-position: 100% 99%;
  background-repeat: no-repeat;
  /* width: 100%; */
  min-height: 120px;
  background-size: 110px;
}

.splash-container {
  justify-content: center;
  align-items: center;
}

@media screen and (max-width: 760px) {
  .splash-s {
    background-image: url(/static/img/splash_qualifier_red.png);
    background-position: 70% 30%;
    background-repeat: no-repeat;
    background-size: 100px;
    min-height: 200px;
  }

  .splash-left {
      background-image: url(/static/img/splash-info-left.png);
    background-position: 20% 30%;
    background-repeat: no-repeat;
    background-size: 150px;
    min-height: 200px;

  }

  .splash-right {
      background-image: url(/static/img/splash-info-right.png);
    background-position: 90% 88%;
    background-repeat: no-repeat;
    background-size: 150px;
    min-height: 200px;
  }
}

@media screen and (min-width: 761px) and (max-width: 1000px) {
  .splash-s {
    background-image: url(/static/img/splash_qualifier_red.png);
    background-position: 62% 20%;
    background-repeat: no-repeat;
    background-size: 100px;
    min-height: 200px;
  }
  .splash-left {
      background-image: url(/static/img/splash-info-left.png);
    background-position: 10% 35%;
    background-repeat: no-repeat;
    background-size: 150px;
    min-height: 200px;

  }

  .splash-right {
      background-image: url(/static/img/splash-info-right.png);
    background-position: 90% 99%;
    background-repeat: no-repeat;
    background-size: 150px;
    min-height: 200px;
  }
}
</style>